<template>
	<div class="row">
		<b-collapse
			id="collapse-recommendations"
			:visible="isVisible"
			class="col-12 mt-2"
			role="tabpanel"
			@input="$emit('setVisible', isVisible)"
		>
			<div class="recommendations-tags">
				<!-- <b-button
					:variant="selectedTags.includes(button.id) ? 'primary' : 'outline-primary'"
					class="d-flex flex-row align-items-center text-left mr-4 mt-2"
					@click="selectTag(button.id)"
				>
					Все
				</b-button> -->
				<b-button
					variant="primary"
					class="mb-2 w-100 d-lg-none"
					:disabled="!value?.length"
					@click="$emit('reset')"
				>
					Очистить
				</b-button>
				<b-button
					variant="primary"
					class="mr-4 mt-2 d-none d-lg-block"
					:disabled="!value?.length"
					@click="$emit('reset')"
				>
					Очистить
				</b-button>

				<b-button
					v-for="button in tagsRecommendations"
					:key="button.id"
					:variant="value.includes(button.id) ? 'primary' : 'outline-primary'"
					class="d-flex flex-row align-items-center text-left mr-1 mr-md-3 mt-2"
					@click="selectTag(button.id)"
				>
					{{ button.name_ru }}
				</b-button>
				<slot />
			</div>
		</b-collapse>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	name: 'TagsOfRecommendation',
	props: {
		isVisible: {
			type: Boolean,
			default: false,
		},
		value: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			buttons: [],
		};
	},
	async fetch() {
		await this.getTags();
		await this.getUserRecomendations();
	},
	computed: {
		...mapGetters('profile', ['isPersonalRecommendations', 'personalRecommendations', 'tagsRecommendations']),
	},
	watch: {
		'$auth.user': {
			async handler(user) {
				if (user) {
					await this.getUserRecomendations();
				}
			},
			immediate: true,
		},
	},
	methods: {
		...mapActions({
			getPersonalRecommendations: 'profile/getPersonalRecommendations',
			getTagsRecommendations: 'profile/getTagsRecommendations',
		}),
		setSelectedTags() {
			this.$emit('input', this.personalRecommendations);
		},
		async getTags() {
			if (this.tagsRecommendations?.length) return;
			await this.getTagsRecommendations();
		},
		async getUserRecomendations() {
			if (!this.$auth.loggedIn) {
				return;
			}

			if (this.isPersonalRecommendations) {
				this.setSelectedTags();
				return;
			}

			try {
				await this.getPersonalRecommendations();
				this.setSelectedTags();

				this.$emit('setIsAutocompleted', true);
			} catch (error) {
				if (error.response && error.response.status === 401) {
					console.warn('User not authenticated in TagsOfRecommendation');
					return;
				}
				console.error('Error fetching user recommendations:', error);
			}
		},
		selectTag(tag) {
			let selectedTags = [...this.value];

			if (this.value.includes(tag)) {
				selectedTags = [...this.value.filter((el) => el !== tag)];
			} else {
				selectedTags.push(tag);
			}
			this.$emit('input', selectedTags);
			this.$emit('change', selectedTags);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '~/assets/styles/sk_variables';
@import "~/assets/styles/bootstrap/scss/functions";
@import "~/assets/styles/bootstrap/scss/variables";
@import "~/assets/styles/bootstrap/scss/mixins";

.recommendations-tags {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: flex-start;

	@include media-breakpoint-down(sm) {
		button {
			font-size: 0.7rem;
			padding: 0.375rem 0.5rem;
		}
	}
}
</style>
